import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import FormControl from '@material-ui/core/FormControl'

const useStylesContainer = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: (props) => props.mb,
    position: 'relative',
  },
  error: {
    fontSize: 14,
    lineHeight: '16px',
    color: '#D40C20',
    position: 'absolute',
    left: 0,
    top: '100%',
  },
  label: {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 600,
    color: 'rgba(21, 31, 49, 0.8)',
    marginBottom: '4px',
  },
}))

const useInputStyles = makeStyles(() => {
  return {
    root: {
      borderRadius: '6px',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: (props) =>
        props.styleType === 'light' ? 'rgba(21, 31, 49, 0.15)' : '#64686D',
      backgroundColor: (props) =>
        props.styleType === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.15)',
      overflow: 'hidden',
      height: 50,
      '&.focus': {
        borderColor: '#4AA652 !important',
        boxShadow: '0px 4px 6px rgba(74, 166, 82, 0.16)',
      },
    },
    focused: {
      borderColor: '#4AA652 !important',
      boxShadow: '0px 4px 6px rgba(74, 166, 82, 0.16)',
    },
    error: {
      borderColor: '#D40C20 !important',
      boxShadow: '0px 4px 6px rgba(212, 12, 32, 0.16)',
    },
    disabled: {
      borderColor: 'rgba(21, 31, 49, 0.15) !important',
      backgroundColor: 'rgba(229, 229, 229, 1)',
    },
    input: {
      width: '100%',
      height: '100%',
      position: 'relative',
      fontSize: 16,
      letterSpacing: '0.016em',
      padding: '0 16px',
      color: (props) => (props.styleType === 'light' ? '#151F31' : '#B0B0B0'),
      '&::placeholder': {
        opacity: 1,
        color: (props) =>
          props.styleType === 'light' ? 'rgba(21, 31, 49, 0.3)' : '#B0B0B0',
      },
      '&[disabled]': {
        opacity: 1,
        color: (props) => (props.styleType === 'light' ? '#838992' : '#B0B0B0'),
      },
      '&:-webkit-autofill': {
        transitionDelay: '9999s',
        transitionProperty: 'background-color, color',
      },
    },
  }
})

const TextInput = ({
  styleType = 'light',
  mb = 0,
  errorMessage,
  classNameContainer = '',
  label = '',
  ...rest
}) => {
  const classes = useStylesContainer({ mb })

  const inputClasses = useInputStyles({ styleType })

  return (
    <FormControl className={`${classes.root} ${classNameContainer}`}>
      {!!label && <span className={classes.label}>{label}</span>}
      <InputBase classes={inputClasses} error={!!errorMessage} {...rest} />
      {!!errorMessage && <span className={classes.error}>{errorMessage}</span>}
    </FormControl>
  )
}

export default memo(TextInput)
